// extracted by mini-css-extract-plugin
export default {"__":"toggle_____W-K7Z","__switch":"toggle___switch__dBsQs","__slider":"toggle___slider__tUYXU","__slider--checked":"toggle___slider--checked__wKybp"};